<style lang="postcss" scoped>
.footer {
  position: fixed;
  bottom: 0.08rem;
  left: 0.08rem;
  right: 0.08rem;
  max-width: 800px;
  margin: 0 auto;
  height: 0.44rem;
  z-index: 999;
  text-align: center;
  background: rgba(255, 255, 255, 0.75);
  backdrop-filter: saturate(180%) blur(10px);
  border-radius: var(--border-radius-base, 0.28rem);
  box-shadow: 0 0.06rem 0.2rem rgba(0, 0, 0, 0.1);
  transition: 0.25s cubic-bezier(0.27, 1.21, 1, 1);

  &.toolbar {
    transform: translateY(-0.56rem);
  }
}
</style>
<template>
  <footer
    class="footer"
    :class="{toolbar: toolBar.show && toolBar.isNeed}"
  >
    <slot name="content"></slot>
  </footer>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'MyFooter',
  computed: {
    ...mapState(['toolBar'])
  }
}
</script>
